import { TemplateKey } from "../template-keys";
import { FontSizeGroup, FontSizeKey } from "../font-size.config";


export type GenericThemeConfig = {
    validForTemplates?: string[]; // the polltemplate that may use this design -if null it's valid for all templates
    filterKeywords?: string[]; // keyword bason on which the theme can be filtered -  for example on the landing pages
    picture: string;
    previewPicture?: string; // if not there value from "picutre" will be used
    pictureSmallScreen?: string; // if not there value from "picutre" will be used
    colorPalette?: string;
    pollStyleKey?: string;
    /**
     * Theme defaults of the header settings "font size" and "uppercase" (workorder-font-size-setting-2026-09-14,
     * workorder-header-uppercase-toggle-2026-09-15, Nachtrag "Theme-Defaults"). Precedence like colorPalette /
     * pollStyleKey: a value in the poll header wins, then the theme, then m / uppercase. A theme default applies
     * IMMEDIATELY to every existing poll with that theme (nothing is written to the header) - check the poll
     * numbers before adding one to a theme that is already in use.
     */
    fontSize?: FontSizeKey; // preset for all groups
    fontSizes?: Partial<Record<FontSizeGroup, FontSizeKey>>; // per group, overrides fontSize for that group
    disableUppercase?: boolean; // true = title/subtitle/boxes rendered as typed
}

export const genericThemeMap = new Map<string, GenericThemeConfig>([
    ['custom', {
        validForTemplates: [TemplateKey.none],
        picture: '',
        colorPalette: 'default',
    }],
    ['no-theme', {
        previewPicture: '/assets/images/poll-templates/theme-preview/no-theme-preview.webp',
        picture: '',
        colorPalette: 'default',
        pollStyleKey: 'no-background',
    }],
    ['calendar', {
        validForTemplates: [TemplateKey.scheduleNew, TemplateKey.schedule, TemplateKey.advancedNew, TemplateKey.advanced],
        previewPicture: '/assets/images/poll-templates/generic-poll/calendar-with-pencil.webp',
        picture: '/assets/images/poll-templates/generic-poll/calendar-with-pencil.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/calendar-mobile.webp',
        colorPalette: 'red-black'

    }],
    ['human-hands', {
        validForTemplates: [TemplateKey.preference, TemplateKey.advanced, TemplateKey.preferenceNew, TemplateKey.advancedNew],
        previewPicture: '/assets/images/poll-templates/generic-poll/human-hands.webp',
        picture: '/assets/images/poll-templates/generic-poll/human-hands.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/human-hands-mobile.webp',
        colorPalette: 'red-black'


    }],
    ['registration-form', {
        validForTemplates: [TemplateKey.participation, TemplateKey.advanced, TemplateKey.participationNew, TemplateKey.advancedNew],
        previewPicture: '/assets/images/poll-templates//generic-poll/register.webp',
        picture: '/assets/images/poll-templates/generic-poll/register.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/register.webp',
        colorPalette: 'red-black'

    }],
    ['potluck', {
        validForTemplates: [TemplateKey.potluckNew, TemplateKey.potluck, TemplateKey.advancedNew, TemplateKey.advanced],
        previewPicture: '/assets/images/poll-templates/poll-preview/potluck.webp',
        picture: '/assets/images/poll-templates/generic-poll/potluck.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/potluck.webp',
        colorPalette: 'red-black'
    }],

    ['duties', {
        validForTemplates: [TemplateKey.dutiesDate, TemplateKey.dutiesDateNew, TemplateKey.duties, TemplateKey.dutiesNew, TemplateKey.advanced, TemplateKey.advancedNew],
        previewPicture: '/assets/images/poll-templates/poll-preview/duties.webp',
        picture: '/assets/images/poll-templates/generic-poll/duties.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/duties-mobile.webp'
        , colorPalette: 'red-black'
    }],
    ['table-setting-festive-dinner', {
        previewPicture: '/assets/images/poll-templates/generic-poll/table-setting-festive-dinner-mobile.webp',
        picture: '/assets/images/poll-templates/generic-poll/table-setting-festive-dinner.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/table-setting-festive-dinner-mobile.webp',
        colorPalette: 'red-black'

    }],

    ['grilled-vegetable', {
        previewPicture: '/assets/images/poll-templates/generic-poll/grilled-vegetable.webp',
        picture: '/assets/images/poll-templates/generic-poll/grilled-vegetable.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/grilled-vegetable.webp',
        colorPalette: 'red-black'

    }],


    ['football-on-grass', {
        previewPicture: '/assets/images/poll-templates/generic-poll/football-on-grass.webp',
        picture: '/assets/images/poll-templates/generic-poll/football-on-grass.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/football-on-grass-mobile.webp',
        colorPalette: 'red-black'

    }],
    ['board-game', {
        previewPicture: '/assets/images/poll-templates/generic-poll/board-game.webp',
        picture: '/assets/images/poll-templates/generic-poll/board-game.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/board-game.webp',
        colorPalette: 'red-black'

    }],
    ['concert', {
        previewPicture: '/assets/images/poll-templates/generic-poll/concert.webp',
        picture: '/assets/images/poll-templates/generic-poll/concert.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/concert.webp',
        colorPalette: 'red-black'

    }],
    ['car-drivers', {
        previewPicture: '/assets/images/poll-templates/generic-poll/car-drivers.webp',
        picture: '/assets/images/poll-templates/generic-poll/car-drivers.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/car-drivers.webp',
        colorPalette: 'yellow-white'

    }],
    ['gift', {
        previewPicture: '/assets/images/poll-templates/generic-poll/gift.webp',
        picture: '/assets/images/poll-templates/generic-poll/gift.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/gift.webp',
        colorPalette: 'yellow-white'
    }],
    ['street', {
        previewPicture: '/assets/images/poll-templates/generic-poll/street.webp',
        picture: '/assets/images/poll-templates/generic-poll/street.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/street-mobile.webp',
        colorPalette: 'yellow-white'


    }],
    ['wedding-seats', {
        previewPicture: '/assets/images/poll-templates/generic-poll/wedding-seats.webp',
        picture: '/assets/images/poll-templates/generic-poll/wedding-seats.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/wedding-seats-mobile.webp', colorPalette: 'yellow-white'


    }],
    ['sparkler', {
        previewPicture: '/assets/images/poll-templates/generic-poll/sparkler-mobile.webp',
        picture: '/assets/images/poll-templates/generic-poll/sparkler.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/sparkler-mobile.webp'
        , colorPalette: 'yellow-white'

    }],
    ['yoga-mat', {
        previewPicture: '/assets/images/poll-templates/generic-poll/yoga-mat-mobile.webp',
        picture: '/assets/images/poll-templates/generic-poll/yoga-mat.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/yoga-mat-mobile.webp',
        colorPalette: 'yellow-white'

    }],
    ['movie', {
        previewPicture: '/assets/images/poll-templates/generic-poll/movie-mobile.webp',
        picture: '/assets/images/poll-templates/generic-poll/movie.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/movie-mobile.webp'
        , colorPalette: 'red-black'

    }],

    ['reolocation', {
        previewPicture: '/assets/images/poll-templates/generic-poll/moving-box.webp',
        picture: '/assets/images/poll-templates/generic-poll/moving-box.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/moving-box-mobile.webp'
        , colorPalette: 'yellow-white'

    }],
    ['kids', {
        previewPicture: '/assets/images/poll-templates/generic-poll/kids.webp',
        picture: '/assets/images/poll-templates/generic-poll/kids.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/kids.webp'
        , colorPalette: 'yellow-white'

    }],

    ['pizza', {
        previewPicture: '/assets/images/poll-templates/generic-poll/pizza.webp',
        picture: '/assets/images/poll-templates/generic-poll/pizza.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/pizza-mobile.webp'
        , colorPalette: 'yellow-white'

    }],
    ['sushi', {
        previewPicture: '/assets/images/poll-templates/generic-poll/sushi.webp',
        picture: '/assets/images/poll-templates/generic-poll/sushi.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/sushi-mobile.webp'
        , colorPalette: 'yellow-white'

    }],
    ['spaghetti', {
        previewPicture: '/assets/images/poll-templates/generic-poll/spaghetti.webp',
        picture: '/assets/images/poll-templates/generic-poll/spaghetti.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/spaghetti-mobile.webp'
        , colorPalette: 'yellow-white'

    }],
    ['order-food', {
        previewPicture: '/assets/images/poll-templates/generic-poll/order.webp',
        picture: '/assets/images/poll-templates/generic-poll/order.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/order-mobile.webp'
        , colorPalette: 'yellow-white'
    }],
    ['halloween', {
        previewPicture: '/assets/images/poll-templates/generic-poll/halloween.webp',
        picture: '/assets/images/poll-templates/generic-poll/halloween.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/halloween-mobile.webp'
        , colorPalette: 'yellow-white'
    }],
    ['christmas', {
        previewPicture: '/assets/images/poll-templates/generic-poll/christmas.webp',
        picture: '/assets/images/poll-templates/generic-poll/christmas.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/christmas-mobile.webp',
        colorPalette: 'red-black'

    }],
    ['thanksgiving', {
        previewPicture: '/assets/images/poll-templates/generic-poll/thanksgiving.webp',
        picture: '/assets/images/poll-templates/generic-poll/thanksgiving.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/thanksgiving-mobile.webp',
        colorPalette: 'yellow-white'
    }],
    ['friendsgiving', {
        previewPicture: '/assets/images/poll-templates/generic-poll/friendsgiving.jpg',
        picture: '/assets/images/poll-templates/generic-poll/friendsgiving.jpg',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/friendsgiving.jpg',
        colorPalette: 'yellow-white'
    }],
    ['easter-eggs', {
        previewPicture: '/assets/images/poll-templates/generic-poll/easter-eggs.jpg',
        picture: '/assets/images/poll-templates/generic-poll/easter-eggs.jpg',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/easter-eggs.jpg',
        colorPalette: 'yellow-white'
    }],
    ['valentine-hearts', {
        previewPicture: '/assets/images/poll-templates/generic-poll/valentine-hearts.jpg',
        picture: '/assets/images/poll-templates/generic-poll/valentine-hearts.jpg',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/valentine-hearts.jpg',
        colorPalette: 'red-black'
    }],
    ['4th-of-july', {
        previewPicture: '/assets/images/poll-templates/generic-poll/4th-of-july.jpg',
        picture: '/assets/images/poll-templates/generic-poll/4th-of-july.jpg',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/4th-of-july.jpg',
        colorPalette: 'yellow-white'
    }],
    ['people-register', {
        previewPicture: '/assets/images/poll-templates/theme-preview/people-queue-to-register.webp',
        picture: '/assets/images/poll-templates/generic-poll/people-queue-to-register.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/people-queue-to-register.webp',
        colorPalette: 'yellow-white'

    }],
    ['feedback-from-colleague', {
        previewPicture: '/assets/images/poll-templates/theme-preview/feedback-from-colleague.webp',
        picture: '/assets/images/poll-templates/generic-poll/feedback-from-colleague.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/feedback-from-colleague-mobile.webp',
        colorPalette: 'yellow-white'
    }],
    ['american-football', {
        previewPicture: '/assets/images/poll-templates/generic-poll/american-football.webp',
        picture: '/assets/images/poll-templates/generic-poll/american-football.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/american-football-mobile.webp',
        colorPalette: 'yellow-white'

    }],
    ['volunteer-work', {
        previewPicture: '/assets/images/poll-templates/generic-poll/volunteer-work.webp',
        picture: '/assets/images/poll-templates/generic-poll/volunteer-work.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/volunteer-work-mobile.webp',
        colorPalette: 'yellow-white'

    }],
    ['baby-feet-small', {
        filterKeywords: ['baby-shower'],
        previewPicture: '/assets/images/poll-templates/generic-poll/baby-feet-small.webp',
        picture: '/assets/images/poll-templates/generic-poll/baby-feet-small.webp',
        pictureSmallScreen: '/assets/images/poll-templates/generic-poll/baby-feet-small.webp',
        colorPalette: 'red-black',
        pollStyleKey: 'tile-background',

    }],
])

